import styles from "./index.module.less";
import { Typography } from "antd";
import classNames from "classnames";
import SVGIcon from "@/components/SVGIcon";
import ArrowRightIcon from "@/assets/imgs/arrow_line.svg?react";
export interface ChannelCardProps {
  img?: string;
  desc?: string;
  date?: string;
  vertical?: boolean;
  position?: "top" | "bottom";
  type?: "default" | "more";
  link?: string;
}
const { Paragraph } = Typography;
const ChannelCard = ({
  img,
  desc,
  date,
  vertical = false,
  position = "top",
  type = "default",
  onClick,
  link,
}: ChannelCardProps & {
  onClick?: () => void;
}) => {
  const renderVerticalCard = () => {
    return (
      <div
        className={styles.verticalCard}
        onClick={() => {
          window.open(link, "_blank");
        }}
      >
        {/* <div className={styles.contentBg}></div>
          <WhiteBg /> */}
        <div className={styles.img}>
          <img src={img} alt="" />
        </div>
        <div
          className={classNames(styles.content, {
            [styles[position]]: position,
          })}
        >
          <div className={styles.contentBg}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="145"
              height="103"
              viewBox="0 0 145 103"
              fill="none"
            >
              <path
                d="M36.909 2.75892C38.0344 1.63275 39.5612 1 41.1532 1H138C141.314 1 144 3.68629 144 7V68.2039C144 69.9988 143.196 71.6993 141.81 72.8391L107.994 100.635C106.92 101.518 105.574 102 104.184 102H7.00001C3.6863 102 1 99.3137 1 96V41.1784C1 39.5879 1.63153 38.0624 2.7558 36.9374L36.909 2.75892Z"
                fill="black"
                fill-opacity="0.4"
              />
              <path
                d="M138 0.75C141.452 0.75 144.25 3.54822 144.25 7V68.2041C144.25 70.0737 143.413 71.8451 141.969 73.0322L108.152 100.828C107.034 101.747 105.631 102.25 104.184 102.25H7C3.54822 102.25 0.75 99.4518 0.75 96V41.1787C0.75 39.5219 1.408 37.9327 2.5791 36.7607L36.7324 2.58203C37.9046 1.40906 39.495 0.75 41.1533 0.75H138Z"
                stroke="white"
                stroke-opacity="0.2"
                stroke-width="0.5"
              />
            </svg>
          </div>
          <div className={styles.contentInner}>
            <div className={styles.desc}>
              <Paragraph
                ellipsis={{
                  rows: 2,
                  expandable: false,
                }}
              >
                {desc}
              </Paragraph>
            </div>
            <div className={styles.date}>
              {date}
            </div>
          </div>
        </div>
      </div>
    );
  };
  const renderHorizontalCard = () => {
    return (
      <div
        className={styles.horizontalCard}
        onClick={() => {
          window.open(link, "_blank");
        }}
      >
        <div className={styles.content}>
          <div className={styles.date}>
            {date}
          </div>
          <div className={styles.desc}>
            <Paragraph
              ellipsis={{
                rows: 2,
                expandable: false,
              }}
            >
              {desc}
            </Paragraph>
          </div>
        </div>
      </div>
    );
  };
  const renderMoreCard = () => {
    return (
      <div
        className={styles.moreCard}
        onClick={onClick}
      >
        MORE
        <SVGIcon icon={<ArrowRightIcon />} width={20} />
      </div>
    );
  };
  if (type === "more") {
    return renderMoreCard();
  }
  return <>{vertical ? renderVerticalCard() : renderHorizontalCard()}</>;
};
export default ChannelCard;
